import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function BankReconciliations() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api(`/bank-reconciliations`).then(r => r.json()).then(setItems).catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Bank Reconciliations</h1>
          <Link to="/accounting/bank-reconciliations/new" className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">New Reconciliation</Link>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50"><tr><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Account</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Statement Date</th><th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Statement Balance</th><th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Difference</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th></tr></thead>
            <tbody className="divide-y divide-gray-200">
              {items.map(item => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium"><Link to={`/accounting/bank-reconciliations/${item.id}`} className="text-emerald-600 hover:text-emerald-800">{item.accountName}</Link></td>
                  <td className="px-6 py-4 text-gray-900">{item.statementDate}</td>
                  <td className="px-6 py-4 text-right font-mono">{item.statementBalance.toFixed(2)}</td>
                  <td className="px-6 py-4 text-right font-mono hidden md:table-cell"><span className={item.difference === 0 ? 'text-green-600' : 'text-red-600'}>{item.difference.toFixed(2)}</span></td>
                  <td className="px-6 py-4"><span className={`px-3 py-1 rounded-full text-xs font-medium ${item.status === 'COMPLETED' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>{item.status.replace(/_/g, ' ')}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <div className="text-center py-12 text-gray-500">No reconciliations yet.</div>}
        </div>
      </div>
    </Layout>
  );
}
